//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs'
import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
export default {
  components: {
    'bread-crumbs': breadCrumbs
  },
  props: {
    title: { // 标题
      type: String, default: ''
    },
    text: { // 描述
      type: String, default: ''
    },
    time: { // 更新时间
      type: Number, default: 0
    }
  },
  data () {
    return {
      newTime: dayjs(this.time).format('YYYY-MM-DD HH:mm')
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
